export const theme = {
    common: {
        delete: '削除'
    },
    modal: {
        cancelText: '取消',
        saveText: '保存',
        okText: 'はい',
        duplicationsCheckText: '重複チェック',
        duplicationsTitle: '重複チェックリスト',
        themeName: 'テーマ名',
        baseThemeBelonging: 'ベーステーマのルート',
        column: {
            themeId: 'テーマID',
            category1: 'カテゴリー1',
            category2: 'カテゴリー2',
            themeName: 'テーマ名'
        },
        baseTheme: {
            addTitle: 'ベーステーマの追加',
            editTitle: 'ベーステーマの編集',
            name: 'ベーステーマ名'
        },
        clientTheme: {
            addTitle: 'クライアントテーマの追加',
            editTitle: 'クライアントテーマの編集',
            name: 'クライアントテーマ名'
        }
    },
    baseTheme: {
        title: 'ベーステーマ',
        column: {
            baseThemeName: 'ベーステーマ名',
            createdDate: '作成日',
            createdBy: '作成者'
        }
    },
    clientTheme: {
        title: 'クライアントテーマ',
        column: {
            clientThemeName: 'クライアントテーマ名',
            createdDate: '作成日',
            createdBy: '作成者'
        }
    },
    error: {
        duplicatedNameMsg: '存在している重複名'
    },
    warningMsg: {
        deleteConfirm: '「{{name}}」削除します。問題ないでしょうか。',
        optSuccess: '処理が正常終了しました。',
        optError: '処理が失敗しました。',
        baseThemeDeleteError:
            'ベーステーマ：「{{baseThemeName}}」が下記リライアントテーマに設定されてます {{clientThemes}} ご確認ください。',
        clientThemeDeleteError:
            'クライアントテーマ：「{{clientThemeName}}」が下記クライアントに設定されてます：{{clients}} ご確認ください。'
    }
}
